import { apiFetch } from './api';

/**
 * Attestation vue par la personne qui détient le jeton : la formation et
 * l'état de SA signature. Aucune authentification — le jeton fait foi.
 */
export function getSignatureAttestation(token) {
  return apiFetch(`/signature-attestation/${token}`);
}

/** Signe l'attestation (image PNG en data URL tracée sur le canvas). */
export function signerAttestation(token, { image, nom }) {
  return apiFetch(`/signature-attestation/${token}`, {
    method: 'POST',
    body: JSON.stringify({ image, nom }),
  });
}
